import { takeLatest } from 'redux-saga/effects';
import {
  GENERATE_RECONCILIATION_REQUEST,
  QUERY_RECONCILIATION_REQUEST,
  LOAD_RECONCILIATION_HEADER_REQUEST,
  LOAD_RECONCILIATION_TRANSACTIONS_REQUEST,
  VIEW_RECONCILIATION_REPORT_REQUEST,
  FETCH_RECONCILIATION_FILTERS_REQUEST,
  FETCH_RECONCILIATION_LOGS_REQUEST,
  SAVE_RECONCILIATION_REPORT_REQUEST,
  UPDATE_ORGANISATION_TAX_BALANCE_REQUEST,
} from '../constants';
import { generateReconciliationSaga } from './generateReconciliationSaga';
import { queryReconciliationSaga } from './queryReconciliationSaga';
import { loadReconciliationHeaderSaga } from './loadReconciliationHeaderSaga';
import { loadReconciliationTransactionsSaga } from './loadReconciliationTransactionsSaga';
import { viewReconciliationReportSaga } from './viewReconciliationReportSaga';
import { fetchReconciliationFiltersSaga } from './fetchReconciliationFiltersSaga';
import { fetchReconciliationLogsSaga } from './fetchReconciliationLogsSaga';
import { updateOrganisationTaxBalanceSaga } from './updateOrganisationTaxBalanceSaga';
import { saveReconciliationReportSaga } from './saveReconciliationReportSaga';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* reconciliationSaga() {
  yield takeLatest(GENERATE_RECONCILIATION_REQUEST, generateReconciliationSaga);
  yield takeLatest(QUERY_RECONCILIATION_REQUEST, queryReconciliationSaga);
  yield takeLatest(
    LOAD_RECONCILIATION_HEADER_REQUEST,
    loadReconciliationHeaderSaga
  );
  yield takeLatest(
    LOAD_RECONCILIATION_TRANSACTIONS_REQUEST,
    loadReconciliationTransactionsSaga
  );
  yield takeLatest(
    VIEW_RECONCILIATION_REPORT_REQUEST,
    viewReconciliationReportSaga
  );
  yield takeLatest(
    FETCH_RECONCILIATION_FILTERS_REQUEST,
    fetchReconciliationFiltersSaga
  );
  yield takeLatest(
    FETCH_RECONCILIATION_LOGS_REQUEST,
    fetchReconciliationLogsSaga
  );
  yield takeLatest(
    SAVE_RECONCILIATION_REPORT_REQUEST,
    saveReconciliationReportSaga
  );

  yield takeLatest(
    UPDATE_ORGANISATION_TAX_BALANCE_REQUEST,
    updateOrganisationTaxBalanceSaga
  );
}
